export enum QuestionnaireQuestionItemMap {
  "item.description" = "item.description",
  "item.naicsCode" = "item.naicsCode",
  "item.name" = "item.name",
  "item.sku" = "item.sku",
  "item.unspsc" = "item.unspsc"
}
